import { DatePipe } from '@angular/common';
import { IDateFilterParams } from 'ag-grid-community';

export class GainsGridUtil {
  private datePipe: DatePipe;

  constructor() {
    this.datePipe = new DatePipe(navigator.language ? navigator.language : 'en-US');
  }
  formatDate(date: Date | string, format = 'MM/dd/yyyy h:mm a'): string {
    return this.datePipe.transform(date, format) || '';
  }

  dateFilterParams: IDateFilterParams = {
    comparator: (filterDate: Date, cellValue: string) => {
      if (!cellValue) return -1;

      const cellDate = new Date(cellValue);
      if (isNaN(cellDate.getTime())) return -1;

      const normalizedFilterDate = new Date(filterDate);
      normalizedFilterDate.setHours(0, 0, 0, 0);

      const normalizedCellDate = new Date(cellDate);
      normalizedCellDate.setHours(0, 0, 0, 0);

      if (normalizedCellDate.getTime() === normalizedFilterDate.getTime()) return 0;
      return normalizedCellDate < normalizedFilterDate ? -1 : 1;
    }
  };

  formatCurrency(value: number | string): string {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numberValue)) return '';

    return new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numberValue);
  }

  formatNumber(value: number | string): string {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numberValue)) return '';

    return new Intl.NumberFormat(navigator.language, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numberValue);
  }
}

// Export a utility function for formatting grouped numbers (with commas) for display
export function formatGroupedNumber(value: number | string): string {
  if (value == null) return '';
  const num = typeof value === 'string' ? Number(value.replace(/,/g, '')) : value;
  return isNaN(num) ? String(value) : num.toLocaleString('en-US');
}
